<template>
  <div class="container-xs">
    <h2 class="title">My Xsensible community</h2>
    <p class="subtitle">
      Fill the fields below to sign up
    </p>
    <form class="form-box" @submit.prevent="signup">
      <div class="form-control-radio">
        <div>
          <input type="radio" value="M" v-model="gender" id="male" />
          <label for="male">Male</label>
        </div>
        <div>
          <input type="radio" value="F" v-model="gender" id="female" />
          <label for="female">Female</label>
        </div>
      </div>
      <div class="form-control">
        <input
          type="text"
          v-model="firstName"
          id="firstName"
          placeholder="First Name"
        />
        <label for="firstName">First Name</label>
      </div>
      <div class="form-control">
        <input
          type="text"
          v-model="surname"
          id="surname"
          placeholder="Surname"
        />
        <label for="surname">Last Name</label>
      </div>
      <div class="form-control">
        <input
          v-model="email"
          type="email"
          required
          id="email"
          placeholder="Emailadres"
        />
        <label for="email">Emailadres</label>
      </div>
      <div class="form-control">
        <input
          :type="showPassword ? 'text' : 'password'"
          id="password"
          required
          v-model="password"
          placeholder="Password"
          @input="validatePassword"
        />
        <label for="password">Password</label>
        <img
          alt="Eye icon"
          :src="passwordIcon"
          class="show-password"
          @click="showPassword = !showPassword"
        />
      </div>
      <div class="error" v-show="$store.state.errorMessage">
        {{ $store.state.errorMessage }}
      </div>
      <button
        :disabled="$store.state.isLoading || !passwordIsValid"
        type="submit"
        class="btn btn-black btn-full"
      >
        <Loader v-if="$store.state.isLoading" />
        {{ $store.state.isLoading ? '' : 'Sign up' }}
      </button>
    </form>
    <div style="margin-top: 41px;">
      <h2 class="title">Xsensible community</h2>
      <p class="subtitle">
        Already have an account?
      </p>
    </div>
    <router-link to="login" class="btn btn-black btn-full">Log in</router-link>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'Signup',
  components: { Loader },
  data() {
    return {
      firstName: '',
      surname: '',
      email: '',
      password: '',
      gender: '',
      showPassword: false,
      passwordIsValid: true
    }
  },
  computed: {
    passwordIcon() {
      return this.showPassword
        ? require('../assets/icons/eye-off.svg')
        : require('../assets/icons/eye.svg')
    }
  },
  methods: {
    signup() {
      if (!this.validate()) {
        return this.$store.commit('setErrorMessage', 'Please fill all fields')
      }
      this.$store.commit('setLoading', true)
      this.$store
        .dispatch('signup', {
          firstName: this.firstName,
          surname: this.surname,
          email: this.email,
          password: this.password,
          gender: this.gender
        })
        .then(() => this.$router.push('step-1'))
    },
    validate() {
      return (
        this.firstName &&
        this.surname &&
        this.email &&
        this.password &&
        this.passwordIsValid
      )
    },
    validatePassword() {
      this.$store.commit('setErrorMessage', null)
      this.passwordIsValid = true
      if (this.password.length < 6) {
        this.passwordIsValid = false
        this.$store.commit(
          'setErrorMessage',
          'The password must contain at least 6 characters.'
        )
      }
      if (!/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g.test(this.password)) {
        this.passwordIsValid = false
        this.$store.commit(
          'setErrorMessage',
          'The password must contain a special character (other than a-z and 0-9).'
        )
      }
      if (!/\d/.test(this.password)) {
        this.passwordIsValid = false
        this.$store.commit(
          'setErrorMessage',
          'The password must contain a number (0-9).'
        )
      }
      if (!/[A-Z]+/.test(this.password)) {
        this.passwordIsValid = false
        this.$store.commit(
          'setErrorMessage',
          'The password must contain a capital letter (A-Z).'
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/forms.scss';
.title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: unset;
}

.subtitle {
  font-weight: normal;
  line-height: 1.5;
}
</style>
